document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.shop-by-category-slider-container');

  containers.forEach(container => {
    const track = container.querySelector('.shop-by-category-slider-track');
    const slides = container.querySelectorAll('.shop-by-category-slide');
    const prevBtn = container.querySelector('.slider-button--prev');
    const nextBtn = container.querySelector('.slider-button--next');
    const dotsContainer = container.nextElementSibling;

    if (!track || slides.length === 0) return;

    // Determine number of visible slides per view
    const slidesPerView = window.innerWidth > 1024 ? 4 : window.innerWidth > 768 ? 3 : 1.5;

    // Show dots only on desktop and if more than visible slides
    const showDots = window.innerWidth > 768 && slides.length > slidesPerView;
    let dots = [];

    if (showDots && dotsContainer) {
      const numDots = Math.ceil(slides.length / slidesPerView);
      dotsContainer.innerHTML = ''; // clear existing
      for (let i = 0; i < numDots; i++) {
        const dot = document.createElement('button');
        dot.classList.add('pagination-dot');
        if (i === 0) dot.classList.add('active');
        dotsContainer.appendChild(dot);
        dots.push(dot);

        dot.addEventListener('click', () => {
          const scrollAmount = i * track.offsetWidth;
          track.scrollTo({ left: scrollAmount, behavior: 'smooth' });
          setActiveDot(i);
        });
      }
    }

    const setActiveDot = (index) => {
      dots.forEach(d => d.classList.remove('active'));
      if (dots[index]) dots[index].classList.add('active');
    };

    const updateActiveDotOnScroll = () => {
      if (!dots.length) return;
      const scrollLeft = track.scrollLeft;
      const totalWidth = track.scrollWidth - track.clientWidth;
      const stepWidth = totalWidth / (dots.length - 1 || 1);
      const index = Math.round(scrollLeft / stepWidth);
      setActiveDot(index);
    };

    const updateArrows = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.style.display = track.scrollLeft > 10 ? 'flex' : 'none';
      nextBtn.style.display = (track.scrollLeft < maxScroll - 10 && slides.length > slidesPerView) ? 'flex' : 'none';
    };

    updateArrows();

    track.addEventListener('scroll', () => {
      updateArrows();
      updateActiveDotOnScroll();
    });

    prevBtn.addEventListener('click', () => {
      track.scrollBy({ left: -track.offsetWidth, behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', () => {
      track.scrollBy({ left: track.offsetWidth, behavior: 'smooth' });
    });
  });
});
